<template>
  <v-toolbar flat class="mb-6">
    <v-toolbar-title>
      {{ title }}
      <span></span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="accent"
            router
            to="/application"
            v-on="on"
          >
            <v-icon dark>mdi-apps</v-icon>
          </v-btn>
        </template>
        <span>{{ $tc("application.name", 0) }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="primary"
            router
            to="/application/create"
            v-on="on"
            v-if="permitted('Application.Create')"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("common.create") }}</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  name: "ApplicationToolbar",
  props: {
    title: String,
  },
};
</script>

<style>
</style>